import { ELOQUENT } from 'config/constants';

/**
 * Register user
 * @param {Object} data
 * @returns {Promise}
 */
export function register(data) {
    return ELOQUENT.Auth.register(data);
}

/**
 * Login user with email and password
 * @param {String} email
 * @param {String} password
 * @returns {Promise}
 */
export function login(email, password) {
    return ELOQUENT.Auth.login(email, password);
}

/**
 * Login user via social provider
 * @param {String} provider
 * @param {String} token
 * @returns {Promise}
 */
export function loginSocial(provider, token) {
    return ELOQUENT.Auth.socialLogin(provider, token);
}

/**
 * Sets the the authorization token for api requests
 * @param {String} token
 */
export function setApiRequestToken(token) {
    ELOQUENT.setApiRequestToken(token);
}

/**
 * Unsets the the authorization token for api requests
 */
export function unsetApiRequestToken() {
    ELOQUENT.unsetApiRequestToken();
}

/**
 * Logout user
 * @returns {Promise}
 */
export function logout() {
    return ELOQUENT.Auth.logout();
}

/**
 * request a password reset code for the given email
 * @param {String} email
 * @returns {Promise}
 */
export function requestPasswordReset(email) {
    return ELOQUENT.Auth.sendResetPasswordCode(email);
}

/**
 * reset the user's password
 * @param {String} code
 * @param {String} password
 * @returns {Promise}
 */
export function resetPassword(code, password) {
    return ELOQUENT.Auth.resetPassword(code, password);
}
